import React from 'react';
import { Form } from 'react-bootstrap';
import { FormEditField } from './FormEditField';

export function InputField(props) {
    return (
        <Form.Group>
            <FormEditField {...props} />
        </Form.Group>
    );
}
